import React, {Component} from 'react';
import {Tooltip, Modal, ModalHeader, ModalBody, InputGroupAddon, InputGroupText, InputGroup} from "reactstrap";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import PropTypes from 'prop-types';
import api from 'api';
import LoadingSpinner from "components/LoadingSpinner";
import {FormattedMessage} from "react-intl";

class PauseButton extends Component {

  constructor(props) {
    super(props);

    this.state = {
      tooltip: false,
      copyTooltip: false,
      tooltipOpen: false,
      modal: false,
      link: null,
      loading: false
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle(property) {
    this.setState({[property]: !this.state[property]}, () => {
      if (property === 'modal' && this.state.modal && !this.state.link) {
        this.setState({loading: true});
        api.surveyResponse.getContinueLink(this.props.surveyResponse.id)
          .then(link => this.setState({link: link, loading: false}))
      }
    })
  }

  render() {
    const {tooltip, modal, copyTooltip, link, loading, tooltipOpen} = this.state;

    const pauseModal = <Modal isOpen={modal} size="xl" toggle={() => this.toggle('modal')}>
      <ModalHeader toggle={() => this.toggle('modal')} tag="h2">Przerywanie wypełniania ankiety</ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        {loading ? <LoadingSpinner/> : <React.Fragment>
          <p>Aby kontynuować wypełnianie ankiety użyj poniższego odnośnika:</p>
          <InputGroup>
            <InputGroupAddon addonType="prepend">{link}</InputGroupAddon>
            <InputGroupAddon addonType="append" id="copy-button" className="mr-0">
              <CopyToClipboard text={link}>
                <InputGroupText>
                  <a><i className="fas fa-copy text-primary" /></a>
                </InputGroupText>
              </CopyToClipboard>
            </InputGroupAddon>
            <Tooltip
              delay={0}
              placement="bottom"
              isOpen={copyTooltip}
              target={'copy-button'}
              toggle={() => this.toggle('copyTooltip')}
            >
              Kliknij, aby skopiować link
            </Tooltip>
          </InputGroup>
        </React.Fragment>}
      </ModalBody>
    </Modal>;

    return (
      <React.Fragment>
        <span  id="pause-button" className="pointer" style={{height: 'fit-content'}} onClick={() => this.toggle('modal')}>
          <Tooltip
              target={"pause-button"}
              isOpen={tooltipOpen}
              toggle={() => this.setState({tooltipOpen: !tooltipOpen})}
          ><FormattedMessage id="footer.pauseButton.text">{msg => msg}</FormattedMessage></Tooltip>
          <i className="fas fa-pause"/> {this.props.showText && <span className={"d-inline-block d-lg-none"}><FormattedMessage id="footer.pauseButton.text">{msg => msg}</FormattedMessage></span>}
        </span>
        {this.props.showIcon && <Tooltip
          delay={0}
          placement="bottom"
          isOpen={tooltip}
          target={'pause-button'}
          toggle={() => this.toggle('tooltip')}
        ><FormattedMessage id="footer.pauseButton.text">{msg => msg}</FormattedMessage></Tooltip>}
        {pauseModal}
      </React.Fragment>
    )
  }
}

PauseButton.defaultProps = {
  showText: true
};

PauseButton.propTypes = {
  showText: PropTypes.bool.isRequired,
  surveyResponse: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired
};

export default PauseButton;